import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Header from "../../components/Header/Header";
import { GetInvoicesThunk } from "../../redux/thunks/GetInvoicesThunk";
import InvoiceTable from "../../components/InvoiceTable/InvoiceTable";
import InvoicesHeader from "../../components/PagesHeaders/InvoicesHeader/InvoicesHeader";
import ReceiptForm from "../../components/ReceiptForm/ReceiptForm";

const Invoices = () => {
    const dispatch = useDispatch();
    const invoices = useSelector(state => state.invoices);
    const send_receipt_form = useSelector(state => state.send_receipt_form);

    // Получение списка счетов при первой отрисовке компонента
    useEffect(() => {
        dispatch(GetInvoicesThunk());
    }, [dispatch]);

    return (
        <>
            { send_receipt_form.open && <ReceiptForm/> }
            <Header component={ <InvoicesHeader/> }/>
            <div className="page">
                <div className="page__content">
                    <InvoiceTable/>
                </div>
            </div>
        </>
    );
};

export default Invoices;